import { formatIfIsoDate } from '@utils/dateUtils'
import type { EChartsCoreOption } from 'echarts/core'

export const ALLOWED_COL_SPANS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const

export function buildTitle(title?: string): EChartsCoreOption['title'] {
  return title
    ? { text: title, left: 'center', textStyle: { fontSize: 14 } }
    : undefined
}

export const CHART_GRID = {
  top: '14%',
  left: '2%',
  right: '2%',
  bottom: '14%',
  containLabel: true
}

export const CHART_TOOLTIP = {
  trigger: 'axis',
  backgroundColor: '#1f2937',
  borderColor: '#374151',
  borderWidth: 1,
  textStyle: {
    color: '#f9fafb'
  }
}

export const CHART_COLORS = [
  '#2979ff',
  '#2a9aad',
  '#1822a4',
  '#c892ef',
  '#FF8D06',
  '#3365cd',
  '#34c2af',
  '#040080',
  '#aa50fa'
]

export const AXIS_STYLE = {
  axisLine: { lineStyle: { color: '#354A63' } },
  axisTick: { lineStyle: { color: '#354A63' } },
  splitLine: { lineStyle: { color: '#354A63' } },
  axisLabel: { color: '#ffffff', formatter: (value) => formatIfIsoDate(value) }
}

export const CHART_TYPES_ARRAY = [
  'bar-chart',
  'box-plot',
  'heatmap',
  'line-chart',
  'pie-chart',
  'map-chart'
] as const

export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/

export const MAX_NATIVE_LEGEND_CATEGORIES = 12

export const COMMON_MAP_STYLES = {
  itemStyle: {
    areaColor: '#2b2d38',
    borderColor: '#ffffff33'
  },
  emphasis: {
    itemStyle: {
      borderColor: '#ffffff88',
      borderWidth: 1
    }
  },
  select: {
    itemStyle: {
      borderColor: '#ffffff55',
      borderWidth: 1
    }
  }
}
